// Determinization for heuristicBot.js's lookahead rollout search - see that
// file's own header comment for the full design. The engine state is a
// fully transparent JS object (every deck's exact order is a real, visible
// array), so a naive forward simulation could "cheat" by using a player's
// literal future draw order to plan around it - something no real player
// (human or otherwise) actually knows about their own shuffled deck. This
// reshuffles a player's deck via the seeded RNG before simulating their
// future turns, sampling one honest, plausible "what might I draw" world -
// the player still gets full credit for knowing WHICH cards are in their
// deck (that's real information), just not the order they'll come up in.
//
// Deliberately does NOT touch hand/discard/inPlay/setAside - those aren't
// hidden information (a player's current hand and discard pile contents
// are visible), only deck order is.

import { shuffle } from '../../rng/rng';

export function determinizePlayerDeck(state, playerId) {
  const player = state.players.find((p) => p.id === playerId);
  const [shuffledDeck, nextRngState] = shuffle(player.deck, state.meta.rngState);
  return {
    ...state,
    meta: { ...state.meta, rngState: nextRngState },
    players: state.players.map((p) => (p.id === playerId ? { ...p, deck: shuffledDeck } : p)),
  };
}

// Reshuffles every player's deck - a rollout sample needs an honest guess
// at BOTH players' future draws, not just the searching player's, since a
// 2-player self-play rollout simulates the opponent's turns too.
export function determinizeAllDecks(state) {
  return state.players.reduce((s, p) => determinizePlayerDeck(s, p.id), state);
}
